import React from "react";
import { FormPartialAddress } from "../../../Onboarding/components/FormPartialAddress";
import { useDynamicFormEngineConfig } from "../../context/DynamicFormEngineConfigContext";
import { useDynamicFormJurisdiction } from "../../context/DynamicFormJurisdictionContext";
import { IDynamicFieldProps } from "../../types";
import { isFieldRequired } from "../../utils/fieldRules";

export const DynamicFieldAddress: React.FC<IDynamicFieldProps> = ({
  field,
  name,
  disabled
}) => {
  const { defaultCountry } = useDynamicFormEngineConfig();
  const country = useDynamicFormJurisdiction();
  return (
    <FormPartialAddress
      country={country ?? defaultCountry}
      name={name}
      label={field.label}
      disabled={disabled}
      showRequirements={isFieldRequired(field)}
    />
  );
};
